module.exports = __webpack_public_path__ + "static/img/18-北京市八一学校.31e3fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/18-北京市八一学校.png
// module id = vh1A
// module chunks = 0